// Redirigir evento wheel y forzar overflow al chat del bot si está abierto
function robustShopAIChatScrollAndOverflow() {
    // Forzar overflow y max-height en el chat externo y su hijo de mensajes
    function applyOverflow() {
        const chat = document.querySelector('.shop-ai-chat-window.active');
        if (chat) {
            chat.style.overflowY = 'auto';
            chat.style.overflowX = 'hidden';
            chat.style.maxHeight = '90vh';
            chat.style.height = '70vh';
            const messages = chat.querySelector('.shop-ai-chat-messages');
            if (messages) {
                messages.style.overflowY = 'auto';
                messages.style.overflowX = 'hidden';
                messages.style.maxHeight = '60vh';
            }
        }
    }
    // Observer para cambios en el DOM
    const observer = new MutationObserver(applyOverflow);
    observer.observe(document.body, { subtree: true, attributes: true, childList: true });
    // Intentar al cargar
    applyOverflow();

    // Redirigir evento wheel al chat del bot si está abierto y el mouse está sobre el chat
    let isMouseOverChat = false;
    document.addEventListener('mouseover', function(e) {
        const chat = document.querySelector('.shop-ai-chat-window.active');
        if (!chat) { isMouseOverChat = false; return; }
        const messages = chat.querySelector('.shop-ai-chat-messages');
        if (messages && messages.contains(e.target)) {
            isMouseOverChat = true;
        } else {
            isMouseOverChat = false;
        }
    }, true);
    document.addEventListener('wheel', function(e) {
        const chat = document.querySelector('.shop-ai-chat-window.active');
        if (!chat || !isMouseOverChat) return;
        const messages = chat.querySelector('.shop-ai-chat-messages');
        if (!messages) return;
        // Solo si el mouse está sobre el chat, redirigir el scroll
        const scrollTop = messages.scrollTop;
        const scrollHeight = messages.scrollHeight;
        const height = messages.clientHeight;
        const delta = e.deltaY;
        if (scrollHeight <= height) return;
        // Evitar scroll en el body si el chat puede scrollear
        if ((delta < 0 && scrollTop === 0) || (delta > 0 && scrollTop + height >= scrollHeight)) {
            e.preventDefault();
        } else {
            messages.scrollTop += delta;
            e.preventDefault();
        }
    }, { passive: false });
}
robustShopAIChatScrollAndOverflow();
// @ts-nocheck
document.addEventListener('DOMContentLoaded', function() {
    // Sync toggle state function
    window.syncToggleState = function() {
        const mobileMenu = document.getElementById('mobile-menu');
        const toggleButton = document.querySelector('.header-smg__mobile-toggle');
        const headerSmg = document.querySelector('.header-smg');
        
        if (!mobileMenu || !toggleButton || !headerSmg) return;
        
        const hamburgerPath = toggleButton.querySelector('.header-smg__hamburger-path');
        const closePath = toggleButton.querySelector('.header-smg__close-path');
        const toggleText = toggleButton.querySelector('.header-smg__mobile-toggle-text');
        
        if (!hamburgerPath || !closePath) return;
        
        // Check current menu state
        const isActive = mobileMenu.classList.contains('header-smg__mobile-menu--active');
        
        if (isActive) {
            // Active menu: show close icon
            if (hamburgerPath instanceof HTMLElement) hamburgerPath.style.display = 'none';
            if (closePath instanceof HTMLElement) closePath.style.display = 'block';
            headerSmg.classList.add('header-smg__close-path--active');
            if (toggleText instanceof HTMLElement) {
                toggleText.textContent = 'Close';
            }
        } else {
            // Inactive menu: show hamburger icon
            if (hamburgerPath instanceof HTMLElement) hamburgerPath.style.display = 'block';
            if (closePath instanceof HTMLElement) closePath.style.display = 'none';
            headerSmg.classList.remove('header-smg__close-path--active');
            
            if (toggleText instanceof HTMLElement) {
                toggleText.textContent = 'Menu';
            }
        }
    };

    function cloneMobileToggle() {
      const originalToggle = document.querySelector('.header-smg__mobile-menu');
      const targetContainer = document.body;
      
      if (!originalToggle || !targetContainer || window.innerWidth > 768) {
        return;
      }
      
      if (originalToggle && targetContainer && window.innerWidth <= 768) {
        const existingClone = document.querySelector('.hero-smg__mobile-toggle-clone');
        if (existingClone) {
          existingClone.remove();
        }
        
        const clonedToggle = originalToggle.cloneNode(true);
        clonedToggle.classList.add('hero-smg__mobile-toggle-clone');
        
        clonedToggle.addEventListener('click', function(e) {
          const mobileMenu = document.getElementById('mobile-menu');
          if (mobileMenu) {
            mobileMenu.classList.toggle('header-smg__mobile-menu--active');
            // Sync visual state after toggle
            if (window.syncToggleState) {
              window.syncToggleState();
            }
          }
        });
        
        targetContainer.appendChild(clonedToggle);
      }
    }
    
    cloneMobileToggle();
    
    window.addEventListener('resize', function() {
      cloneMobileToggle();
    });
    
    // Observer to detect mobile menu class changes
    const mobileMenu = document.getElementById('mobile-menu');
    if (mobileMenu) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    // Sync visual state when classes change
                    if (window.syncToggleState) {
                        window.syncToggleState();
                    }
                }
            });
        });
        
        observer.observe(mobileMenu, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    // Observer to detect header class changes
    const headerEl = document.querySelector('.header-smg');
    if (headerEl) {
        let previousHasActive = headerEl.classList.contains('header-smg__close-path--active');
        
        const headerObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const currentHasActive = headerEl.classList.contains('header-smg__close-path--active');
                    
                    // Only act if the state actually changed from active to inactive
                    if (previousHasActive && !currentHasActive) {
                        // Header lost active class, force close both menus
                        const mobileMenu = document.getElementById('mobile-menu');
                        const clonedMenu = document.querySelector('.hero-smg__mobile-toggle-clone');
                        
                        if (mobileMenu && mobileMenu.classList.contains('header-smg__mobile-menu--active')) {
                            mobileMenu.classList.remove('header-smg__mobile-menu--active');
                        }
                        if (clonedMenu && clonedMenu.classList.contains('header-smg__mobile-menu--active')) {
                            clonedMenu.classList.remove('header-smg__mobile-menu--active');
                        }
                    }
                    
                    // Update previous state
                    previousHasActive = currentHasActive;
                }
            });
        });
        
        headerObserver.observe(headerEl, {
            attributes: true,
            attributeFilter: ['class']
        });
    }
  });

  // Main header toggle button event
  const toggleMobileMenu = document.querySelector('.header-smg__mobile-toggle');
      if (toggleMobileMenu) {
          toggleMobileMenu.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              // Find original mobile menu by ID
              const mobileMenu = document.getElementById('mobile-menu');
              
              if (mobileMenu) {
                  // Check current state
                  const isCurrentlyOpen = mobileMenu.classList.contains('header-smg__mobile-menu--active');
                  
                  if (isCurrentlyOpen) {
                      // Closing: remove class from both menus
                      mobileMenu.classList.remove('header-smg__mobile-menu--active');
                      const clonedMenu = document.querySelector('.hero-smg__mobile-toggle-clone');
                      if (clonedMenu) {
                          clonedMenu.classList.remove('header-smg__mobile-menu--active');
                      }
                  } else {
                      // Opening: add class to both menus
                      mobileMenu.classList.add('header-smg__mobile-menu--active');
                      const clonedMenu = document.querySelector('.hero-smg__mobile-toggle-clone');
                      if (clonedMenu) {
                          clonedMenu.classList.add('header-smg__mobile-menu--active');
                      }
                  }
                  
                  // Sync visual state
                  if (window.syncToggleState) {
                      window.syncToggleState();
                  }
              }
          });
      }
  
  // Prevent contact button from interfering with mobile menu
  const contactButton = document.querySelector('.header-smg__contact');
  if (contactButton) {
      contactButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Ensure toggle visual state remains correct
          if (window.syncToggleState) {
              window.syncToggleState();
          }
          
          // Add contact button functionality here
          // For example, open a modal or redirect to contact page
          console.log('Contact button clicked');
      });
  }

  // Prevent clicks on menu content from closing it
  const mobileMenu = document.getElementById('mobile-menu');
  if (mobileMenu) {
      mobileMenu.addEventListener('click', function(e) {
          // Only prevent closing if clicking on nav, not background
          const mobileNav = this.querySelector('.header-smg__mobile-nav');
          if (mobileNav && mobileNav.contains(e.target)) {
              e.stopPropagation();
          }
      });
  }

  // Close menu when clicking outside
  document.addEventListener('click', function(e) {
      const mobileMenu = document.getElementById('mobile-menu');
      const toggleButton = document.querySelector('.header-smg__mobile-toggle');
      const clonedMenu = document.querySelector('.hero-smg__mobile-toggle-clone');
      
      if (!mobileMenu || !toggleButton) return;
      
      // Check if menu is open (either original or cloned)
      const isMenuOpen = mobileMenu.classList.contains('header-smg__mobile-menu--active') || 
                         (clonedMenu && clonedMenu.classList.contains('header-smg__mobile-menu--active'));
      
      if (isMenuOpen) {
          // Check if click is outside toggle button and both menus
          const isClickInsideToggle = toggleButton.contains(e.target);
          const isClickInsideMenu = mobileMenu.contains(e.target);
          const isClickInsideClonedMenu = clonedMenu && clonedMenu.contains(e.target);
          
          // Check if clicking on the nav content inside cloned menu
          const isClickOnClonedNav = clonedMenu && e.target.closest('.header-smg__mobile-nav');
          
          if (!isClickInsideToggle && !isClickInsideMenu && !isClickInsideClonedMenu) {
              // Close the menu
              mobileMenu.classList.remove('header-smg__mobile-menu--active');
              
              // Sync clone state if exists
              if (clonedMenu) {
                  clonedMenu.classList.remove('header-smg__mobile-menu--active');
              }
              
              // Sync visual state
              if (window.syncToggleState) {
                  window.syncToggleState();
              }
          } else if (isClickInsideClonedMenu && !isClickOnClonedNav) {
              // If clicking on the cloned menu background (not nav content), close it
              mobileMenu.classList.remove('header-smg__mobile-menu--active');
              
              if (clonedMenu) {
                  clonedMenu.classList.remove('header-smg__mobile-menu--active');
              }
              
              if (window.syncToggleState) {
                  window.syncToggleState();
              }
          }
      }
  });

   // Mobile menu elements reorganization
   // COMENTADO: Este código reorganizaba los elementos del menú móvil cuando había 5 o más elementos,
   // insertando divs header-smg__mobile-global que rompían los selectores nth-child del CSS.
   // Se comenta para permitir que el grid CSS funcione correctamente con cualquier número de elementos.
   /*
    const itemMobileMenus = document.querySelectorAll('.header-smg__mobile-nav-item');

        if (itemMobileMenus.length >= 5) {
        const globalContainer = document.createElement('div');
        globalContainer.classList.add('header-smg__mobile-global');
        
        const firstThreeItems = Array.from(itemMobileMenus).slice(0, 3);
        const firstItem = firstThreeItems[0];
        const parentElement = firstItem?.parentNode;
        
        if (firstItem && parentElement) {
            parentElement.insertBefore(globalContainer, firstItem);
            
            const contentContainer = document.createElement('div');
            contentContainer.classList.add('header-smg__mobile-content');
            
            if (firstThreeItems[0]) {
                globalContainer.appendChild(firstThreeItems[0]);
            }
            
            firstThreeItems.slice(1, 3).forEach((item) => {
                item.classList.remove('header-smg__mobile-nav-item--large');
                contentContainer.appendChild(item);
            });
            
            globalContainer.appendChild(contentContainer);
        }
    }
    
        if (itemMobileMenus.length >= 5) {
        // Create second global container
        const secondGlobalContainer = document.createElement('div');
        secondGlobalContainer.classList.add('header-smg__mobile-global');

        const nextTwoItems = Array.from(itemMobileMenus).slice(3, 5);
        const fourthItem = nextTwoItems[0];
        const parentElement = fourthItem?.parentNode;

        if (fourthItem && parentElement) {
            parentElement.insertBefore(secondGlobalContainer, fourthItem);

            secondGlobalContainer.appendChild(fourthItem); // principal

            const secondContentContainer = document.createElement('div');
            secondContentContainer.classList.add('header-smg__mobile-content');
            if (nextTwoItems[1]) {
                nextTwoItems[1].classList.remove('header-smg__mobile-nav-item--large');
                secondContentContainer.appendChild(nextTwoItems[1]); // contenido
            }
            secondGlobalContainer.appendChild(secondContentContainer);
        }
    }
    */